// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"9ee792af","832":"9c63d220"}[chunkId] + ".chunk.js";
};